import { ISS_CLASSIFICATION_LABELS } from '../../helpers/sectorInsights/fetchInsightCells'

// Een effectgrootte hoort op twee decimalen; een aantal organisaties niet.
// '2.00 organisaties' suggereert een precisie die er niet is — je kunt geen
// twee honderdste organisatie hebben. Hele getallen blijven daarom heel.
const toonWaarde = (value) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) return '—'
    return Number.isInteger(value) ? String(value) : value.toFixed(2)
}

/**
 * @typedef {object} CellRow
 * @property {string} label - naam van de rij (effect, mechanisme, …)
 * @property {number} value - de gerangschikte waarde
 * @property {string} [unit] - eenheid van de waarde
 * @property {number} [n] - respondenten achter deze rij
 * @property {number} [orgs] - organisaties achter deze rij
 * @property {({kind: string, label: string, provisional: boolean, gatesFailed: string[]}|null)} [quality] - kwaliteitsoordeel
 */

/** Interne weergave van het kwaliteitsoordeel. Extern wordt dit nooit getoond. */
const qualityLabel = (quality) => {
    if (!quality) return 'onbekend'
    if (quality.kind === 'iss') return ISS_CLASSIFICATION_LABELS[quality.label] || quality.label
    return quality.label
}

/**
 * Een gerangschikte lijst met per rij het kwaliteitsoordeel.
 *
 * Rijen die een poort niet halen worden GEMARKEERD, niet weggelaten: een
 * ingekorte ranglijst suggereert een volledigheid die er niet is, en maakt
 * "weinig vertrouwen" ononderscheidbaar van "geen data".
 * AI-CONTEXT: See docs/patterns.md#backend-per-row-strength-score (regel 7)
 *
 * @param {object} props
 * @param {Array<CellRow>} props.rows - de rijen van de cel, al gesorteerd
 * @param {boolean} [props.measurable] - false = er was niets te meten (≠ uitkomst nul)
 */
const RankingRender = ({ rows, measurable = true }) => {
    if (measurable === false) {
        return <p className="intelligence-state">Er is nog niet genoeg gemeten om hier iets over te zeggen.</p>
    }
    if (!rows || rows.length === 0) {
        return <p className="intelligence-state">Deze cel leverde geen rijen op.</p>
    }

    return (
        <table className="intelligence-ranking">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Wat</th>
                    <th>Waarde</th>
                    <th>Respondenten</th>
                    <th>Organisaties</th>
                    <th>Onderbouwing</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row, index) => (
                    <tr
                        key={row.label}
                        className={row.quality && row.quality.provisional === false
                            ? undefined
                            : 'intelligence-ranking__row--provisional'}
                    >
                        <td>{index + 1}</td>
                        <td>{row.label}</td>
                        <td>
                            {toonWaarde(row.value)}
                            {row.unit ? ` ${row.unit}` : ''}
                        </td>
                        <td>{typeof row.n === 'number' ? row.n : '—'}</td>
                        <td>{typeof row.orgs === 'number' ? row.orgs : '—'}</td>
                        <td>
                            {qualityLabel(row.quality)}
                            {row.quality && row.quality.gatesFailed && row.quality.gatesFailed.length > 0 && (
                                <span className="intelligence-gate-note">
                                    {' '}(poort {row.quality.gatesFailed.join(', ')} niet gehaald)
                                </span>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default RankingRender
